import { GET_BRANCH_LOCATIONS } from '../../redux/actions';
import { getApi } from '../../services/api';

export const getLocationsDropdown = async function getLocationsDropdown() {
	const resp = await getApi('/company/locations/dropdown');
	if (resp.type === 'success') {
		return resp.locations;
	}
	return [];
};


export const getLocationOptions = () => async (dispatch) => {
	const resp = await getApi('/company/locations/dropdown');
	if (resp.type === 'success') {
		dispatch({ type: GET_BRANCH_LOCATIONS, payload: resp.locations });
		return resp.locations;
	}
};
